import React from 'react';
import { Input } from '../../../components/tailwind/input';
import { Card, CardContent } from '../../../components/tailwind/card';
import TailwindSelect from '../../../components/tailwind/TailwindSelect';
import RequiredAsterisk from '../../../components/shared/RequiredAsterisk';
import { TEMPLATE_CATEGORIES, TEMPLATE_LANGUAGES } from '../constants/templateConstants';

export default function TemplateDetailsForm({ formData, setFormData, validationErrors }) {
  return (
    <Card className="border-gray-200 dark:border-slate-800 bg-white dark:bg-slate-900">
      <CardContent className="p-6 space-y-4">
        <h3 className="font-medium text-gray-900 dark:text-white mb-2">Template Details</h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
              Template Name <RequiredAsterisk />
            </label>
            <Input
              placeholder="e.g., welcome_message"
              className={`bg-gray-50 dark:bg-slate-950 border-gray-200 dark:border-slate-800 text-gray-900 dark:text-white ${
                validationErrors.name ? 'border-red-500 focus-visible:ring-red-500' : ''
              }`}
              value={formData.name}
              onChange={(e) => setFormData('name', e.target.value.toLowerCase().replace(/\s+/g, '_'))}
            />
            {validationErrors.name && <p className="text-xs text-red-500">{validationErrors.name}</p>}
            <p className="text-xs text-gray-500">Lowercase, underscores only</p>
          </div>

          <div className="space-y-2">
            <TailwindSelect
              label={
                <>
                  <span>Category</span>
                  <RequiredAsterisk />
                </>
              }
              placeholder="Select category"
              items={TEMPLATE_CATEGORIES}
              value={formData.category}
              onChange={(val) => setFormData('category', val)}
              invalid={!!validationErrors.category}
              errorText={validationErrors.category}
              triggerClassName="bg-gray-50 dark:bg-slate-950 border-gray-200 dark:border-slate-800"
            />
          </div>

          <div className="space-y-2">
            <TailwindSelect
              label={
                <>
                  <span>Language</span>
                  <RequiredAsterisk />
                </>
              }
              placeholder="Select language"
              items={TEMPLATE_LANGUAGES}
              value={formData.language}
              onChange={(val) => setFormData('language', val)}
              invalid={!!validationErrors.language}
              errorText={validationErrors.language}
              triggerClassName="bg-gray-50 dark:bg-slate-950 border-gray-200 dark:border-slate-800"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
